export * from './kunden-arts-filter.component';
export * from './kunden-arts-filter.component.module';